module.exports = __webpack_public_path__ + "fonts/023ca6c3d42c896cb84cf0d3cdc29cf1.svg";